export default "__VITE_ASSET__358d0a8d__"